import React, { useState } from 'react';
import { Search, Plus, Users, PhoneCall, TrendingUp, Calendar, ChevronDown, MoreVertical } from 'lucide-react';

const RealEstateEmployees = () => {
  const [activePerformanceTab, setActivePerformanceTab] = useState('Top Performances');
  const [activeDirectoryTab, setActiveDirectoryTab] = useState('Employee List');
  const [searchQuery, setSearchQuery] = useState('');

  const topPerformers = [
    { name: 'Sarah Mitchell', role: 'Managing Partner', productivity: 98, trend: '+3%', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop' },
    { name: 'Michael Chen', role: 'Senior Property Manager', productivity: 96, trend: '+5%', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop' },
    { name: 'Jennifer Davis', role: 'Sales Director', productivity: 95, trend: '+2%', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop' },
    { name: 'David Martinez', role: 'Property Manager', productivity: 94, trend: '+4%', avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop' }
  ];

  const employees = [
    { id: 1, name: 'Sarah Mitchell', role: 'Managing Partner', department: 'Executive Leadership', productivity: 98, joinedDate: 'January 15, 2020', type: 'Full-Time', phone: '(555) 123-4567', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop' },
    { id: 2, name: 'Michael Chen', role: 'Senior Property Manager', department: 'Property Management', productivity: 96, joinedDate: 'March 22, 2020', type: 'Full-Time', phone: '(555) 234-5678', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop' },
    { id: 3, name: 'Jennifer Davis', role: 'Sales Director', department: 'Sales', productivity: 95, joinedDate: 'June 10, 2019', type: 'Full-Time', phone: '(555) 345-6789', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop' },
    { id: 4, name: 'David Martinez', role: 'Property Manager', department: 'Property Management', productivity: 94, joinedDate: 'August 5, 2021', type: 'Full-Time', phone: '(555) 456-7890', avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop' },
    { id: 5, name: 'Emily Johnson', role: 'Leasing Agent', department: 'Leasing', productivity: 92, joinedDate: 'February 18, 2022', type: 'Full-Time', phone: '(555) 567-8901', avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop' },
    { id: 6, name: 'Robert Taylor', role: 'Maintenance Supervisor', department: 'Operations', productivity: 91, joinedDate: 'November 3, 2020', type: 'Full-Time', phone: '(555) 678-9012', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop' },
    { id: 7, name: 'Amanda Foster', role: 'Marketing Manager', department: 'Marketing', productivity: 89, joinedDate: 'April 12, 2021', type: 'Full-Time', phone: '(555) 789-0123', avatar: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=100&h=100&fit=crop' },
    { id: 8, name: 'James Wilson', role: 'Accountant', department: 'Finance', productivity: 88, joinedDate: 'September 25, 2022', type: 'Part-Time', phone: '(555) 890-1234', avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop' }
  ];

  const recentAttendance = [
    { name: 'Michael Chen', role: 'Senior Property Manager', status: 'Punctual', time: '8:57 AM', statusColor: 'bg-green-500' },
    { name: 'Jennifer Davis', role: 'Sales Director', status: 'Arrived Late', time: '9:13 AM', statusColor: 'bg-yellow-500' },
    { name: 'David Martinez', role: 'Property Manager', status: 'Punctual', time: '8:45 AM', statusColor: 'bg-green-500' }
  ];

  const filteredEmployees = employees.filter(emp =>
    emp.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    emp.role.toLowerCase().includes(searchQuery.toLowerCase()) ||
    emp.department.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-black text-white p-3 md:p-6">
      {/* Header */}
      <div className="mb-4 md:mb-6">
        <h1 className="text-2xl md:text-4xl font-bold mb-1">Employees</h1>
        <p className="text-gray-400 text-xs md:text-sm">Manage your workforce and track employee performance</p>
      </div>

      {/* Top Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6 mb-4 md:mb-6">
        {/* Total Employees Card */}
        <div className="bg-blue-600 rounded-lg p-4 md:p-6 relative overflow-hidden">
          <div className="relative z-10">
            <div className="flex items-center justify-between mb-3 md:mb-4">
              <Users size={24} className="text-white md:hidden" />
              <Users size={32} className="text-white hidden md:block" />
              <button className="flex items-center gap-1 md:gap-2 text-xs md:text-sm text-white/80 hover:text-white">
                All Time <ChevronDown size={14} />
              </button>
            </div>
            <p className="text-white/80 text-xs md:text-sm mb-1 md:mb-2">Total Employees</p>
            <p className="text-3xl md:text-5xl font-bold mb-1 md:mb-2">250</p>
            <p className="text-white/70 text-[10px] md:text-sm">Active attendance count for today</p>
          </div>
        </div>

        {/* Recent Attendance Card */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-4 md:p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
            <PhoneCall size={20} className="text-blue-400 md:hidden" />
            <PhoneCall size={24} className="text-blue-400 hidden md:block" />
            <h3 className="text-sm md:text-lg font-semibold">Recent Attendance</h3>
          </div>
          <div className="space-y-2 md:space-y-3 mb-3 md:mb-4">
            {recentAttendance.map((record, index) => (
              <div key={index} className="flex items-center justify-between">
                <div className="min-w-0">
                  <p className="font-medium text-xs md:text-sm truncate">{record.name}</p>
                  <p className="text-[10px] md:text-xs text-gray-400 truncate">{record.role}</p>
                </div>
                <div className="text-right flex-shrink-0 ml-2">
                  <span className={`text-[10px] md:text-xs px-1.5 md:px-2 py-0.5 md:py-1 rounded ${record.statusColor} bg-opacity-20 text-white`}>
                    {record.status}
                  </span>
                  <p className="text-[10px] md:text-xs text-gray-400 mt-0.5 md:mt-1">{record.time}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="text-[10px] md:text-xs text-gray-500 mb-2 md:mb-3">230+ other attendance records logged today</p>
          <button className="w-full py-1.5 md:py-2 bg-gray-800 hover:bg-gray-700 rounded text-xs md:text-sm transition-all">
            See All Attendance
          </button>
        </div>

        {/* Today's Attendance Snapshot */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-4 md:p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
            <TrendingUp size={20} className="text-green-400 md:hidden" />
            <TrendingUp size={24} className="text-green-400 hidden md:block" />
            <h3 className="text-sm md:text-lg font-semibold">Today's Snapshot</h3>
          </div>
          <div className="grid grid-cols-3 gap-2 md:gap-4 mb-3 md:mb-4">
            <div className="text-center">
              <p className="text-xl md:text-3xl font-bold">235</p>
              <p className="text-[10px] md:text-xs text-gray-400">Checked-in</p>
            </div>
            <div className="text-center">
              <p className="text-xl md:text-3xl font-bold">1</p>
              <p className="text-[10px] md:text-xs text-gray-400">Late</p>
            </div>
            <div className="text-center">
              <p className="text-xl md:text-3xl font-bold">14</p>
              <p className="text-[10px] md:text-xs text-gray-400">Absent</p>
            </div>
          </div>
          <p className="text-[10px] md:text-xs text-gray-400">4% workforce consistently late in the last 2 weeks</p>
        </div>

        {/* Leave Request Card */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-4 md:p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
            <Calendar size={20} className="text-purple-400 md:hidden" />
            <Calendar size={24} className="text-purple-400 hidden md:block" />
            <h3 className="text-sm md:text-lg font-semibold">Leave Request</h3>
          </div>
          <p className="text-2xl md:text-4xl font-bold mb-0.5 md:mb-1">61</p>
          <p className="text-xs md:text-sm text-green-400 mb-0.5 md:mb-1">+2.3%</p>
          <p className="text-[10px] md:text-xs text-gray-400 mb-3 md:mb-4">Pending Requests</p>
          <button className="w-full py-1.5 md:py-2 bg-purple-600 hover:bg-purple-700 rounded text-xs md:text-sm font-medium transition-all">
            View All Requests
          </button>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
        {/* Top Performances */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-4 md:p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          {/* Tabs */}
          <div className="flex gap-2 md:gap-4 mb-3 md:mb-4 border-b border-gray-700 overflow-x-auto pb-2">
            {['Top Performances', 'Needs Attention', 'All Insights'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActivePerformanceTab(tab)}
                className={`pb-1 md:pb-2 text-xs md:text-sm transition-all whitespace-nowrap ${
                  activePerformanceTab === tab
                    ? 'border-b-2 border-blue-500 text-white font-semibold'
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Top Performers List */}
          <div className="space-y-3 md:space-y-4">
            {topPerformers.map((performer, index) => (
              <div key={index} className="flex items-center justify-between">
                <div className="flex items-center gap-2 md:gap-3 min-w-0">
                  <img src={performer.avatar} alt={performer.name} className="w-8 md:w-10 h-8 md:h-10 rounded-full object-cover flex-shrink-0" />
                  <div className="min-w-0">
                    <p className="font-medium text-xs md:text-sm truncate">{performer.name}</p>
                    <p className="text-[10px] md:text-xs text-gray-400 truncate">{performer.role}</p>
                  </div>
                </div>
                <div className="text-right flex-shrink-0 ml-2">
                  <p className="font-bold text-xs md:text-sm">{performer.productivity}%</p>
                  <p className="text-[10px] md:text-xs text-green-400">{performer.trend}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Employee Directory */}
        <div className="lg:col-span-2 bg-black border-2 border-gray-400 rounded-lg p-4 md:p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          {/* Header with Tabs and Actions */}
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 mb-3 md:mb-4">
            <div className="flex gap-2 md:gap-4 border-b border-gray-700 overflow-x-auto pb-2 w-full md:w-auto">
              {['Employee List', 'Leave Request', "Today's Attendance"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveDirectoryTab(tab)}
                  className={`pb-1 md:pb-2 text-xs md:text-sm transition-all whitespace-nowrap ${
                    activeDirectoryTab === tab
                      ? 'border-b-2 border-blue-500 text-white font-semibold'
                      : 'text-gray-400 hover:text-white'
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="flex gap-2 w-full md:w-auto">
              <button className="text-xs md:text-sm text-gray-400 hover:text-white hidden sm:block">View All</button>
              <button className="flex items-center gap-1.5 md:gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-blue-600 hover:bg-blue-700 rounded text-xs md:text-sm font-medium transition-all flex-1 md:flex-none justify-center">
                <Plus size={14} />
                <span className="hidden sm:inline">Add New Employee</span>
                <span className="sm:hidden">Add</span>
              </button>
            </div>
          </div>

          {/* Search Bar */}
          <div className="relative mb-3 md:mb-4">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={14} />
            <input
              type="text"
              placeholder="Search employees..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-9 md:pl-10 pr-4 py-2 bg-gray-900 border border-gray-700 rounded text-xs md:text-sm text-white placeholder-gray-400 focus:outline-none focus:border-gray-600"
            />
          </div>

          {/* Employee Table - Desktop */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-700">
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">NAME</th>
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">ROLE</th>
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">PRODUCTIVITY</th>
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">JOINED DATE</th>
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">TYPE</th>
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">PHONE</th>
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400"></th>
                </tr>
              </thead>
              <tbody>
                {filteredEmployees.map((employee) => (
                  <tr key={employee.id} className="border-b border-gray-800 hover:bg-gray-900 transition-all">
                    <td className="py-3 px-2">
                      <div className="flex items-center gap-3">
                        <img src={employee.avatar} alt={employee.name} className="w-8 h-8 rounded-full object-cover" />
                        <span className="text-sm">{employee.name}</span>
                      </div>
                    </td>
                    <td className="py-3 px-2">
                      <div>
                        <p className="text-sm">{employee.role}</p>
                        <p className="text-xs text-gray-400">{employee.department}</p>
                      </div>
                    </td>
                    <td className="py-3 px-2 text-sm">{employee.productivity}%</td>
                    <td className="py-3 px-2 text-sm">{employee.joinedDate}</td>
                    <td className="py-3 px-2">
                      <span className={`text-xs px-2 py-1 rounded ${
                        employee.type === 'Full-Time' ? 'bg-blue-500/20 text-blue-400' : 'bg-purple-500/20 text-purple-400'
                      }`}>
                        {employee.type}
                      </span>
                    </td>
                    <td className="py-3 px-2 text-sm text-gray-400">{employee.phone}</td>
                    <td className="py-3 px-2">
                      <button className="text-gray-400 hover:text-white">
                        <MoreVertical size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Employee Cards - Mobile */}
          <div className="md:hidden space-y-3">
            {filteredEmployees.slice(0, 5).map((employee) => (
              <div key={employee.id} className="bg-gray-900/50 rounded-lg p-3 border border-gray-700">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2 min-w-0">
                    <img src={employee.avatar} alt={employee.name} className="w-10 h-10 rounded-full object-cover flex-shrink-0" />
                    <div className="min-w-0">
                      <p className="text-sm font-medium truncate">{employee.name}</p>
                      <p className="text-[10px] text-gray-400 truncate">{employee.role}</p>
                    </div>
                  </div>
                  <button className="text-gray-400 hover:text-white flex-shrink-0">
                    <MoreVertical size={16} />
                  </button>
                </div>
                <div className="flex items-center justify-between text-[10px]">
                  <span className={`px-2 py-0.5 rounded ${
                    employee.type === 'Full-Time' ? 'bg-blue-500/20 text-blue-400' : 'bg-purple-500/20 text-purple-400'
                  }`}>
                    {employee.type}
                  </span>
                  <span className="text-gray-400">{employee.productivity}% productivity</span>
                </div>
              </div>
            ))}
            {filteredEmployees.length > 5 && (
              <button className="w-full py-2 text-xs text-gray-400 hover:text-white">
                View all {filteredEmployees.length} employees →
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealEstateEmployees;
